import {countries} from "~/constants/countries";

export function useWadHelpers() {

    const normalizeInput = (raw: unknown) => {
        if(typeof raw === 'string') {
            return raw.trim();
        }
        if(Array.isArray(raw)) {
            return (raw[0]?.trim() ?? '');
        }
        return '';
    }

    const randomColorBySeed = (seed: number|string) => {
        const colors = [
            '#F7C6D0',
            '#F9D1DC',
            '#F4B7C8',
            '#FADCE1',
            '#F6AFC1',
            '#FFE0E0',
            '#FFD8C2',
            '#FFE3D4',
            '#FFCBB3',
            '#FFD4BE',
            '#FFE8D9',
            '#FFF0B3',
            '#FFF3C4',
            '#FFF6D8',
            '#FFEEA8',
            '#FFF2B8',
            '#FFF8E1',
            '#D9F2D9',
            '#E2F8E2',
            '#C7EBCE',
            '#D6F5DD',
            '#E5F9E7',
            '#C8FFD4',
            '#CFF6F5',
            '#D9FAF9',
            '#BFF0EF',
            '#D3F8F7',
            '#E0FBFA',
            '#D1E8FF',
            '#DCEFFF',
            '#BAD7FF',
            '#CDE4FF',
            '#E3F1FF',
            '#D0E0FF',
            '#E6D8FF',
            '#EDE4FF',
            '#D5C8FF',
            '#E2D6FF',
            '#F0ECFF',
            '#F6D9FF',
            '#F4DFFB',
            '#F7EAFF',
            '#E9CFF6',
            '#F2E0FA',
            '#F8EDFF',
            '#F2ECEA',
            '#F7F3F2',
            '#EDE8E5',
            '#F3EEEB',
            '#FAF7F5'
        ];
        if(typeof seed === 'string') {
            seed = [...seed].reduce((sum, ch) => sum + (ch.charCodeAt(0) *3), 0);
        }
        return colors[seed % colors.length];
    }

    const differenceBy = <T, K extends keyof T>(
      source: T[],
      exclude: T[],
      key: K
    ): T[] => {
        const excludeSet = new Set(exclude.map(item => item[key]))
        return source.filter(item => !excludeSet.has(item[key]))
    }

    const isEuroCountry = (isoCode: string) => {
        if (!isoCode) {
            return false;
        }

        const euroZone = new Set([
            'AT', 'BE', 'BG', 'HR', 'CY', 'EE', 'FI', 'FR', 'DE', 'GR',
            'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PT', 'SK', 'SI', 'ES',
            'AD', 'MC', 'SM', 'VA', 'ME', 'XK',
            'GP', 'MQ', 'RE', 'YT', 'BL', 'MF', 'PM' // Overseas territories
        ]);

        return euroZone.has(isoCode.toUpperCase());
    }

    const getCountryByCode = (countryCode: string) => {
        return countries.find((country) => country.code === countryCode);
    }

    const waitForRefValue = (refVar: any, value = false) => {
        return new Promise<void>((resolve) => {
            if (refVar.value === value) {
                return resolve();
            }
            const unwatch = watch(refVar, (newValue) => {
                if (newValue === value) {
                    unwatch();
                    resolve();
                }
            });
        });
    };

    return {
        normalizeInput,
        randomColorBySeed,
        differenceBy,
        isEuroCountry,
        getCountryByCode,
        waitForRefValue
    }
}
